import { Middleware } from 'redux';

import { LOAD_USER, hideLoading, loadUserSuccess, showLoading } from './actions';
import { toast } from 'react-toastify';
import { RootState } from '../../../store/store';
import { RoomService } from '../../auth/room';

const loadUserMiddleware: Middleware<{}, RootState> = ({ dispatch, getState }) => next => (action: any) => {
    next(action);
    // const state = getState()
    if (action.type === LOAD_USER) {
        dispatch(showLoading());

        RoomService.loadUserRoomAccess()
            .then(response => {
                dispatch(loadUserSuccess(response.data))
                dispatch(hideLoading());
            })
            .catch(error => {
                toast.error('Loading user access list failed, Incorrect credentials or server error!');
                dispatch(hideLoading());
            });
    }
}


export const userMiddleware = [loadUserMiddleware];